import type { ReactNode } from 'react';

import VNHelperPanel from './VNHelperPanel';
import VNInfoDrawer from './VNInfoDrawer';

type Props = {
  panelOpen: boolean;
  drawerOpen: boolean;
  helperText?: string;
  helperLink?: string;
  helperContent?: ReactNode;
  helperContentTitle?: string;
  onOpenDrawerFromPanel: () => void;
  onCloseDrawer: () => void;
};

const VNFieldHelpChrome = ({
  panelOpen,
  drawerOpen,
  helperText,
  helperLink,
  helperContent,
  helperContentTitle,
  onOpenDrawerFromPanel,
  onCloseDrawer,
}: Props) => {
  const hasDrawerContent = Boolean(helperContent);
  const showHelperTextInDrawer = Boolean(helperText && !hasDrawerContent);

  return (
    <>
      <VNHelperPanel
        open={panelOpen}
        helperText={helperText}
        helperLink={helperLink}
        hasDrawerContent={hasDrawerContent}
        onOpenDrawer={onOpenDrawerFromPanel}
      />
      {helperContent && drawerOpen && (
        <VNInfoDrawer
          open={drawerOpen}
          title={helperContentTitle}
          helperText={showHelperTextInDrawer ? helperText : undefined}
          helperLink={helperLink}
          onClose={onCloseDrawer}
        >
          {helperContent}
        </VNInfoDrawer>
      )}
    </>
  );
};

export default VNFieldHelpChrome;
